import auctionService from '../../api/auction'

const state = {
}

const mutations = {
}

const actions = {
  getNceTimeline ({ commit }) {
    return new Promise((resolve, reject) => {
      auctionService.getNceTimeline().then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
